import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Optional, Self, ViewChild } from '@angular/core';
import { NgControl } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatFormFieldControl } from '@angular/material/form-field';
import { IField } from '../../../../models/field/field.model';
import { BaseGenericInputComponent } from '../base-generic-input/base-generic-input.component';

@Component({
    selector: 'mat-generic-select-input',
    templateUrl: './generic-select-input.component.html',
    styleUrls: [ '../base-generic-input/base-generic-input.component.scss', './generic-select-input.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: MatFormFieldControl,
            useExisting: GenericSelectInputComponent,
        },
    ],
})
export class GenericSelectInputComponent<T> extends BaseGenericInputComponent<T> {
    @ViewChild('inputEl')
    public inputEl: ElementRef;
    public selectFilter: Record<string, string> = {};

    constructor(
        @Optional()
        @Self()
        protected myNgControl: NgControl,
        protected myChangeDetectorRef: ChangeDetectorRef,
    ) {
        super(myChangeDetectorRef);

        if (this.myNgControl) {
            this.myNgControl.valueAccessor = this;
        }
    }

    public masterToggle(e: MatCheckboxChange, field: IField, options: unknown[]): void {
        if (e) {
            if (!e.source.checked) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                this.inputFormControl.patchValue([] as any);
            } else if (e.source.checked) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                this.inputFormControl.patchValue(options.map((option: unknown) => option[ field.selectData?.valueKey ]) as any);
            }
        }
    }
}
